import { Component, OnInit } from '@angular/core';
import { ContactUsService } from '@app/core/services/contact-us.service';
import { IContactUsList } from '@app/core/models/contact-us.interface';
import { IdentityProvider } from '@app/core/providers/identity/identity-provider';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {

  constructor(
    public contactUsService: ContactUsService,
    private readonly identity: IdentityProvider,
  ) { }

  contactUsLists: IContactUsList;
  loadingContactLists = false;
  hasContactUsList = false;

  ngOnInit() {
    this.loadingContactLists = true;
    this.identity?.isContactUsListSet?.subscribe(isContactUsList => {
      if (
        isContactUsList && this.identity?.contactUsList?.retailContactUsList &&
        this.identity?.contactUsList?.retailContactUsList.length > 0
      ) {
        this.contactUsLists = this.identity.contactUsList;
        this.hasContactUsList = true;
        this.loadingContactLists = false;
      }
    });
  }

}
